import { Component, OnInit } from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss']
})
export class RankingComponent implements OnInit {

  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource;
  constructor() { }

  ngOnInit(): void {
  }

  getUsers() {
    // this.dataSource = new MatTableDataSource(ELEMENT_DATA);
  }

}
